// All AI Utility Tools with full mapping
// Categories: LEAD_SALES, OPERATIONS, SUPPORT, MARKETING, ANALYTICS, FINANCE, LOGISTICS, HR_TEAM

export const industries = [
  { id: 'retail', label: '🛒 Retail / E-commerce / D2C', icon: '🛒' },
  { id: 'services', label: '💇 Services (Salon, Clinic, Coaching)', icon: '💇' },
  { id: 'manufacturing', label: '🏭 Manufacturing / Trading', icon: '🏭' },
  { id: 'realestate', label: '🏠 Real Estate / Construction', icon: '🏠' },
  { id: 'agency', label: '📢 Agency / Freelancer', icon: '📢' },
  { id: 'logistics', label: '🚚 Logistics / Distribution', icon: '🚚' },
  { id: 'other', label: '📦 Other', icon: '📦', hasInput: true }
];

export const teamSizes = [
  { id: 'solo', label: '👤 Just me', icon: '👤' },
  { id: '2-5', label: '👥 2-5 people', icon: '👥' },
  { id: '6-15', label: '👥 6-15 people', icon: '👥' },
  { id: '16-50', label: '🏢 16-50 people', icon: '🏢' },
  { id: '50+', label: '🏢 50+', icon: '🏢' }
];

export const primaryPains = [
  { id: 'LEAD_SALES', label: '📞 Leads come but don\'t convert', icon: '📞' },
  { id: 'OPERATIONS', label: '📊 Daily Excel/WhatsApp chaos', icon: '📊' },
  { id: 'SUPPORT', label: '💬 Customer query overload', icon: '💬' },
  { id: 'MARKETING', label: '📣 Marketing content is hard', icon: '📣' },
  { id: 'ANALYTICS', label: '📈 Have data but no insights', icon: '📈' },
  { id: 'FINANCE', label: '💰 Billing/payment follow-ups missed', icon: '💰' },
  { id: 'LOGISTICS', label: '📦 Stock/delivery issues', icon: '📦' },
  { id: 'HR_TEAM', label: '👥 Team/hiring problems', icon: '👥' },
  { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
];

export const drilldownOptions = {
  LEAD_SALES: {
    question: "What's the exact lead problem?",
    options: [
      { id: 'missed_leads', label: '📵 Calls/WhatsApp get missed', icon: '📵' },
      { id: 'no_followup', label: '🔁 Follow-up not consistent', icon: '🔁' },
      { id: 'cant_identify', label: '🎯 Can\'t identify serious leads', icon: '🎯' },
      { id: 'slow_quotes', label: '📄 Quotes/Proposals take time', icon: '📄' },
      { id: 'dormant_leads', label: '😴 Old leads went dormant', icon: '😴' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  OPERATIONS: {
    question: "What bothers you in operations?",
    options: [
      { id: 'scattered_excel', label: '📑 Everything scattered in Excel', icon: '📑' },
      { id: 'task_tracking', label: '✅ Hard to track tasks', icon: '✅' },
      { id: 'no_meeting_notes', label: '📝 Meeting notes don\'t happen', icon: '📝' },
      { id: 'no_sops', label: '📋 SOPs not documented', icon: '📋' },
      { id: 'time_tracking', label: '⏱️ Don\'t know where time goes', icon: '⏱️' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  SUPPORT: {
    question: "What's the support issue?",
    options: [
      { id: 'repetitive_questions', label: '🔄 Same questions again and again', icon: '🔄' },
      { id: 'review_replies', label: '⭐ Can\'t reply to reviews', icon: '⭐' },
      { id: 'angry_customers', label: '😠 Can\'t identify angry customers', icon: '😠' },
      { id: 'callback_issues', label: '📞 Callback management failing', icon: '📞' },
      { id: 'no_chat_insights', label: '💬 No insights from chat history', icon: '💬' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  MARKETING: {
    question: "What's the marketing problem?",
    options: [
      { id: 'no_ideas', label: '💡 No post ideas', icon: '💡' },
      { id: 'slow_adcopy', label: '✍️ Ad copy takes too long', icon: '✍️' },
      { id: 'hashtag_confusion', label: '#️⃣ Hashtags/targeting confusing', icon: '#️⃣' },
      { id: 'video_scripts', label: '🎬 Video scripts are hard', icon: '🎬' },
      { id: 'newsletter_issues', label: '📧 Newsletter not consistent', icon: '📧' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  ANALYTICS: {
    question: "What's the data problem?",
    options: [
      { id: 'revenue_patterns', label: '📉 Can\'t understand revenue patterns', icon: '📉' },
      { id: 'customer_churn', label: '🚪 Customers churning', icon: '🚪' },
      { id: 'no_competitor_info', label: '🔍 No competitor info', icon: '🔍' },
      { id: 'strategy_unclear', label: '🧭 Hard to decide strategy', icon: '🧭' },
      { id: 'persona_unclear', label: '👤 Customer persona unclear', icon: '👤' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  FINANCE: {
    question: "What's the finance issue?",
    options: [
      { id: 'manual_reconciliation', label: '🔄 Payment reconciliation is manual', icon: '🔄' },
      { id: 'missed_invoices', label: '📩 Invoice follow-ups missed', icon: '📩' },
      { id: 'expenses_uncategorized', label: '🧾 Expenses not categorized', icon: '🧾' },
      { id: 'no_cashflow', label: '💸 No cash flow visibility', icon: '💸' },
      { id: 'manual_gst', label: '📋 GST invoices made manually', icon: '📋' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  LOGISTICS: {
    question: "What's the logistics problem?",
    options: [
      { id: 'stockouts', label: '📦 Stock suddenly runs out', icon: '📦' },
      { id: 'eta_issues', label: '🚛 Hard to communicate delivery ETA', icon: '🚛' },
      { id: 'old_stock', label: '📅 Old stock doesn\'t rotate', icon: '📅' },
      { id: 'supplier_quotes', label: '💵 Comparing supplier quotes is tedious', icon: '💵' },
      { id: 'fleet_issues', label: '🚗 Vehicles not used optimally', icon: '🚗' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  },
  HR_TEAM: {
    question: "What's the team/HR problem?",
    options: [
      { id: 'jd_time', label: '📝 Writing JDs takes time', icon: '📝' },
      { id: 'interview_questions', label: '❓ Interview questions not standard', icon: '❓' },
      { id: 'onboarding_messy', label: '🆕 New hire onboarding is messy', icon: '🆕' },
      { id: 'feedback_not_analyzed', label: '📊 Team feedback not analyzed', icon: '📊' },
      { id: 'manual_offers', label: '📄 Offer letters made manually', icon: '📄' },
      { id: 'other', label: '🔧 Other', icon: '🔧', hasInput: true }
    ]
  }
};

export const budgetOptions = [
  { id: '15k_50k', label: '💰 ₹15K - ₹50K', icon: '💰' },
  { id: 'above_50k', label: '💎 ₹50K+', icon: '💎' }
];

export const readinessOptions = [
  { id: 'yes', label: '✅ Yes, schedule a call', icon: '✅' },
  { id: 'whatsapp', label: '💬 Connect on WhatsApp', icon: '💬' },
  { id: 'exploring', label: '👀 Just exploring for now', icon: '👀' }
];

export const timePreferences = [
  { id: 'morning', label: '🌅 Morning (9 AM - 12 PM)', icon: '🌅' },
  { id: 'afternoon', label: '☀️ Afternoon (12 PM - 4 PM)', icon: '☀️' },
  { id: 'evening', label: '🌆 Evening (4 PM - 7 PM)', icon: '🌆' }
];

// All 60+ tools with full details
export const allTools = {
  // LEAD & SALES TOOLS
  missed_call_lead_capture: {
    id: 'missed_call_lead_capture',
    name: 'AI Missed Call Lead Capture',
    description: 'Grab leads from missed calls + call logs and follow up automatically',
    category: 'LEAD_SALES',
    drilldowns: ['missed_leads'],
    setupDays: '3-5',
    monthlyPrice: 10000
  },
  whatsapp_lead_qualifier: {
    id: 'whatsapp_lead_qualifier',
    name: 'Auto WhatsApp Lead Qualification Bot',
    description: 'Ask qualifying questions on WhatsApp and score leads',
    category: 'LEAD_SALES',
    drilldowns: ['missed_leads', 'cant_identify'],
    setupDays: '3-5',
    monthlyPrice: 10000
  },
  whatsapp_auto_responder: {
    id: 'whatsapp_auto_responder',
    name: 'WhatsApp Auto-Responder + Lead Tagger',
    description: 'Auto-reply, tag by intent, push to Google Sheet/CRM',
    category: 'LEAD_SALES',
    drilldowns: ['missed_leads'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  deal_reminder_engine: {
    id: 'deal_reminder_engine',
    name: 'SMS + WhatsApp Deal Reminder Engine',
    description: 'Sends automatic reminders to prospects for active deals',
    category: 'LEAD_SALES',
    drilldowns: ['no_followup'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  auto_followup_sequence: {
    id: 'auto_followup_sequence',
    name: 'Auto Lead Follow-Up Sequence',
    description: 'Rule-based follow-up sequence + reminders via SMS/WhatsApp',
    category: 'LEAD_SALES',
    drilldowns: ['no_followup'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  lead_priority_scorer: {
    id: 'lead_priority_scorer',
    name: 'AI Lead Priority Scorer',
    description: 'Scores new leads based on text/answers so sales know who to call first',
    category: 'LEAD_SALES',
    drilldowns: ['cant_identify'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  deal_stage_predictor: {
    id: 'deal_stage_predictor',
    name: 'Deal Stage Predictor',
    description: 'Uses criteria to predict likelihood of closing + next best step',
    category: 'LEAD_SALES',
    drilldowns: ['cant_identify'],
    setupDays: '5-7',
    monthlyPrice: 10000
  },
  proposal_generator: {
    id: 'proposal_generator',
    name: 'AI Proposal Generator',
    description: 'Fill form → AI creates proposal doc (PDF/Google Doc)',
    category: 'LEAD_SALES',
    drilldowns: ['slow_quotes'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  smart_quote_builder: {
    id: 'smart_quote_builder',
    name: 'Smart Quote Builder',
    description: 'Enter pricing items → auto generate polished quotes',
    category: 'LEAD_SALES',
    drilldowns: ['slow_quotes'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  winback_engine: {
    id: 'winback_engine',
    name: 'Auto Re-Engage Win-Back Engine',
    description: 'Reaches out to dormant leads with smart offer lines',
    category: 'LEAD_SALES',
    drilldowns: ['dormant_leads'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  lead_source_tracker: {
    id: 'lead_source_tracker',
    name: 'Lead Source Tracker',
    description: 'Tracks which campaign (Meta/Google/Organic) brought each lead',
    category: 'LEAD_SALES',
    drilldowns: ['dormant_leads', 'cant_identify'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  sales_story_creator: {
    id: 'sales_story_creator',
    name: 'Sales Story Creator',
    description: 'AI crafts "why choose you" story for pitches',
    category: 'LEAD_SALES',
    drilldowns: ['slow_quotes'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },

  // OPERATIONS TOOLS
  daily_dashboard: {
    id: 'daily_dashboard',
    name: 'Daily Business Dashboard',
    description: 'Auto-update KPI dashboard (Revenue, leads, costs) in one screen',
    category: 'OPERATIONS',
    drilldowns: ['scattered_excel'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  ops_automation: {
    id: 'ops_automation',
    name: 'AI Ops Automation',
    description: 'Manual Excel → Auto workflows in 7 days',
    category: 'OPERATIONS',
    drilldowns: ['scattered_excel'],
    setupDays: '5-7',
    monthlyPrice: 10000
  },
  team_task_digest: {
    id: 'team_task_digest',
    name: 'Team Task Digest',
    description: '1 email summary of pending + overdue tasks daily',
    category: 'OPERATIONS',
    drilldowns: ['task_tracking'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  task_prioritizer: {
    id: 'task_prioritizer',
    name: 'AI Task Prioritizer',
    description: 'Paste task list → get priority score + schedule',
    category: 'OPERATIONS',
    drilldowns: ['task_tracking'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  meeting_minutes_bot: {
    id: 'meeting_minutes_bot',
    name: 'Smart Meeting Minutes Bot',
    description: 'Record/AI summary + action items PDF',
    category: 'OPERATIONS',
    drilldowns: ['no_meeting_notes'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  meeting_agenda_packager: {
    id: 'meeting_agenda_packager',
    name: 'Meeting Agenda + Auto Minutes Packager',
    description: 'Prep agenda + generate minutes after meeting',
    category: 'OPERATIONS',
    drilldowns: ['no_meeting_notes'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  sop_writer: {
    id: 'sop_writer',
    name: 'AI SOP Writer',
    description: 'Describe a process → AI outputs a step-by-step SOP doc',
    category: 'OPERATIONS',
    drilldowns: ['no_sops'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  voice_knowledge_base: {
    id: 'voice_knowledge_base',
    name: 'Voice-to-Knowledge Base Converter',
    description: 'Voice recordings → structured KB articles',
    category: 'OPERATIONS',
    drilldowns: ['no_sops'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  time_tracker_splitter: {
    id: 'time_tracker_splitter',
    name: 'Automated Time Tracker Splitter',
    description: 'Uploads time logs → organizes by task category',
    category: 'OPERATIONS',
    drilldowns: ['time_tracking'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },

  // SUPPORT TOOLS
  customer_support_bot: {
    id: 'customer_support_bot',
    name: 'AI Customer Support Bot',
    description: 'Trained FAQ bot that can escalate to human (WhatsApp/Website)',
    category: 'SUPPORT',
    drilldowns: ['repetitive_questions'],
    setupDays: '5-7',
    monthlyPrice: 10000
  },
  faq_generator: {
    id: 'faq_generator',
    name: 'AI FAQ Generator from Website Content',
    description: 'Creates FAQs automatically from existing content & answers',
    category: 'SUPPORT',
    drilldowns: ['repetitive_questions'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  review_response_generator: {
    id: 'review_response_generator',
    name: 'AI Review Response Generator',
    description: 'Auto draft replies to Google/MyBiz reviews',
    category: 'SUPPORT',
    drilldowns: ['review_replies'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  auto_review_collector: {
    id: 'auto_review_collector',
    name: 'Auto Review Collector',
    description: 'Send follow-ups asking for feedback post-purchase',
    category: 'SUPPORT',
    drilldowns: ['review_replies'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  sentiment_prioritizer: {
    id: 'sentiment_prioritizer',
    name: 'Sentiment-Based Support Prioritizer',
    description: 'Flags angry messages/emails for urgent action',
    category: 'SUPPORT',
    drilldowns: ['angry_customers'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  complaint_respondent: {
    id: 'complaint_respondent',
    name: 'AI Complaint Respondent',
    description: 'Auto-respond to angry customer messages with tone control',
    category: 'SUPPORT',
    drilldowns: ['angry_customers'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  callback_scheduler: {
    id: 'callback_scheduler',
    name: 'Auto Callback Scheduler',
    description: 'Customers request callback → AI schedules best time + reminds',
    category: 'SUPPORT',
    drilldowns: ['callback_issues'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  chat_transcripts_analyzer: {
    id: 'chat_transcripts_analyzer',
    name: 'AI Chat Transcripts Analyzer',
    description: 'Summarizes past chats, finds topic clusters & improvement areas',
    category: 'SUPPORT',
    drilldowns: ['no_chat_insights'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  feedback_analyzer: {
    id: 'feedback_analyzer',
    name: 'AI Feedback Analyzer',
    description: 'Cluster positive vs negative comments across channels',
    category: 'SUPPORT',
    drilldowns: ['no_chat_insights'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },

  // MARKETING TOOLS
  content_idea_bank: {
    id: 'content_idea_bank',
    name: 'Weekly Content Idea Bank',
    description: 'Pushes 7 social post ideas every Monday',
    category: 'MARKETING',
    drilldowns: ['no_ideas'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  social_post_planner: {
    id: 'social_post_planner',
    name: 'Social Post Planner + Caption Generator',
    description: 'Calendar + Canva caption templates',
    category: 'MARKETING',
    drilldowns: ['no_ideas'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  ad_copy_generator: {
    id: 'ad_copy_generator',
    name: 'Smart Ad Copy Generator',
    description: 'Enter offer + AI outputs 3× ad copies + headlines',
    category: 'MARKETING',
    drilldowns: ['slow_adcopy'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  subject_line_optimizer: {
    id: 'subject_line_optimizer',
    name: 'Subject Line Optimizer',
    description: 'Takes your text → provides high-impact subject lines',
    category: 'MARKETING',
    drilldowns: ['slow_adcopy'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  cta_generator: {
    id: 'cta_generator',
    name: 'Call-to-Action Generator',
    description: 'AI writes multiple high-convert CTAs in seconds',
    category: 'MARKETING',
    drilldowns: ['slow_adcopy'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  hashtag_generator: {
    id: 'hashtag_generator',
    name: 'Hashtag & Topic Generator',
    description: 'Input niche → burst of SEO hashtags + content angles',
    category: 'MARKETING',
    drilldowns: ['hashtag_confusion'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  audience_interest_finder: {
    id: 'audience_interest_finder',
    name: 'Audience Interest Finder',
    description: 'Suggested interest clusters from business brief for Meta ads',
    category: 'MARKETING',
    drilldowns: ['hashtag_confusion'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  video_script_generator: {
    id: 'video_script_generator',
    name: 'AI Short-form Video Script Generator',
    description: 'YouTube/Reels shorts scripts based on product details',
    category: 'MARKETING',
    drilldowns: ['video_scripts'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  newsletter_curator: {
    id: 'newsletter_curator',
    name: 'Newsletter Automated Curator',
    description: 'Your business + AI pulls weekly newsletter content ready to send',
    category: 'MARKETING',
    drilldowns: ['newsletter_issues'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  sms_blast_creator: {
    id: 'sms_blast_creator',
    name: 'AI SMS Blast Creator',
    description: 'Enter offer → 5 SMS templates + send scheduler',
    category: 'MARKETING',
    drilldowns: ['slow_adcopy', 'newsletter_issues'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },

  // ANALYTICS TOOLS
  revenue_variance_alert: {
    id: 'revenue_variance_alert',
    name: 'Daily Revenue Variance Alert',
    description: 'Notifies if revenue dips below expected patterns',
    category: 'ANALYTICS',
    drilldowns: ['revenue_patterns'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  trend_finder: {
    id: 'trend_finder',
    name: 'Trend Finder for Transaction Data',
    description: 'AI highlights unusual spikes/drops weekly',
    category: 'ANALYTICS',
    drilldowns: ['revenue_patterns'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  sales_pattern_finder: {
    id: 'sales_pattern_finder',
    name: 'Sales Pattern Finder',
    description: 'Find which day/hour sales spike + why (based on data patterns)',
    category: 'ANALYTICS',
    drilldowns: ['revenue_patterns'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  churn_predictor: {
    id: 'churn_predictor',
    name: 'Customer Churn Predictor',
    description: 'Flags customers at risk of stopping purchases',
    category: 'ANALYTICS',
    drilldowns: ['customer_churn'],
    setupDays: '5-7',
    monthlyPrice: 10000
  },
  segment_profiler: {
    id: 'segment_profiler',
    name: 'Customer Segment Profiler',
    description: 'Given purchase history → outputs cluster profiles',
    category: 'ANALYTICS',
    drilldowns: ['customer_churn'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  competitor_snapshot: {
    id: 'competitor_snapshot',
    name: 'AI Competitor Snapshot',
    description: 'Auto summary of top competitors from web + social + pricing',
    category: 'ANALYTICS',
    drilldowns: ['no_competitor_info'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  competitor_review_analyzer: {
    id: 'competitor_review_analyzer',
    name: 'Competitor Review Analyzer',
    description: 'Scrapes reviews → provides insights + weak spots',
    category: 'ANALYTICS',
    drilldowns: ['no_competitor_info'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  competitor_pricing_watcher: {
    id: 'competitor_pricing_watcher',
    name: 'Competitor Pricing Watcher',
    description: 'Track competitor prices + alert big changes',
    category: 'ANALYTICS',
    drilldowns: ['no_competitor_info'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  swot_analyzer: {
    id: 'swot_analyzer',
    name: 'AI SWOT Analyzer',
    description: 'Paste business details → get SWOT + quick action points',
    category: 'ANALYTICS',
    drilldowns: ['strategy_unclear'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  growth_hypothesis_generator: {
    id: 'growth_hypothesis_generator',
    name: 'Growth Hypothesis Generator',
    description: 'Input goals → AI outputs testable growth experiments',
    category: 'ANALYTICS',
    drilldowns: ['strategy_unclear'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  customer_persona_generator: {
    id: 'customer_persona_generator',
    name: 'Customer Persona Generator',
    description: 'Create detailed customer avatars from your brief',
    category: 'ANALYTICS',
    drilldowns: ['persona_unclear'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  ai_trend_finder: {
    id: 'ai_trend_finder',
    name: 'AI Trend Finder',
    description: 'Scans web + social signals to show what\'s trending in your niche',
    category: 'ANALYTICS',
    drilldowns: ['strategy_unclear', 'persona_unclear'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },

  // FINANCE TOOLS
  payment_reconciliation: {
    id: 'payment_reconciliation',
    name: 'UPI/Payment Reconciliation Tool',
    description: 'Upload bank export → match payments to orders',
    category: 'FINANCE',
    drilldowns: ['manual_reconciliation'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  invoice_reminder_bot: {
    id: 'invoice_reminder_bot',
    name: 'Invoice Payment Reminder Bot',
    description: 'Schedules polite payment nudges automatically',
    category: 'FINANCE',
    drilldowns: ['missed_invoices'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  late_fee_calculator: {
    id: 'late_fee_calculator',
    name: 'AI Late Fee Calculator',
    description: 'Generate late fees + notifications based on rules',
    category: 'FINANCE',
    drilldowns: ['missed_invoices'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  expense_scanner: {
    id: 'expense_scanner',
    name: 'Expense Receipt Scanner + Categorizer',
    description: 'Upload bill photo → gets categorized in Sheet',
    category: 'FINANCE',
    drilldowns: ['expenses_uncategorized'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  expense_categorizer: {
    id: 'expense_categorizer',
    name: 'Expense Categoriser & Alert',
    description: 'Bank/UPI import → auto categorize + alerts for anomalies',
    category: 'FINANCE',
    drilldowns: ['expenses_uncategorized'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  cashflow_heatmap: {
    id: 'cashflow_heatmap',
    name: 'Cash-Flow Heatmap',
    description: 'Visual map of inflows/outflows week/month',
    category: 'FINANCE',
    drilldowns: ['no_cashflow'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  revenue_cost_analyzer: {
    id: 'revenue_cost_analyzer',
    name: 'Revenue vs Cost Analyzer',
    description: 'Simple report showing margin leaks + recommendations',
    category: 'FINANCE',
    drilldowns: ['no_cashflow'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  cashflow_visualizer: {
    id: 'cashflow_visualizer',
    name: 'Cash Flow Visualizer',
    description: 'Turn numbers into a daily/weekly cash trend chart',
    category: 'FINANCE',
    drilldowns: ['no_cashflow'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  gst_invoice_generator: {
    id: 'gst_invoice_generator',
    name: 'GST Invoice & E-Way Bill Generator',
    description: 'Pick template → generate legal invoice + tracking',
    category: 'FINANCE',
    drilldowns: ['manual_gst'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  tax_deduction_finder: {
    id: 'tax_deduction_finder',
    name: 'Tax Deduction Finder',
    description: 'Scans expense data → recommends deductible patterns',
    category: 'FINANCE',
    drilldowns: ['expenses_uncategorized', 'manual_gst'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },

  // LOGISTICS TOOLS
  stock_alert_system: {
    id: 'stock_alert_system',
    name: 'Stock/Inventory Low-Alert System',
    description: 'Threshold alerts + reorder reminders',
    category: 'LOGISTICS',
    drilldowns: ['stockouts'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  inventory_demand_forecaster: {
    id: 'inventory_demand_forecaster',
    name: 'AI Inventory Demand Forecaster',
    description: 'Predict next month\'s sales by SKU (simple time series)',
    category: 'LOGISTICS',
    drilldowns: ['stockouts'],
    setupDays: '5-7',
    monthlyPrice: 10000
  },
  jit_suggestor: {
    id: 'jit_suggestor',
    name: 'Inventory Just-in-Time Suggestor',
    description: 'Forecasts reorder points using simple demand cues',
    category: 'LOGISTICS',
    drilldowns: ['stockouts'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  delivery_eta_notifier: {
    id: 'delivery_eta_notifier',
    name: 'Delivery ETA Notifier',
    description: 'Track order + auto notify customer updates',
    category: 'LOGISTICS',
    drilldowns: ['eta_issues'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  delivery_eta_predictor: {
    id: 'delivery_eta_predictor',
    name: 'Delivery ETA Predictor',
    description: 'Given pattern + route → predicts delivery windows',
    category: 'LOGISTICS',
    drilldowns: ['eta_issues'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },
  wait_time_notifier: {
    id: 'wait_time_notifier',
    name: 'AI Wait-Time Notifier',
    description: 'Automatically message customers about delays',
    category: 'LOGISTICS',
    drilldowns: ['eta_issues'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  stock_rotation_alert: {
    id: 'stock_rotation_alert',
    name: 'Stock Rotation Alert System',
    description: 'Warns about old stock based on movement patterns',
    category: 'LOGISTICS',
    drilldowns: ['old_stock'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  supplier_price_comparator: {
    id: 'supplier_price_comparator',
    name: 'Supplier Price Comparator',
    description: 'Paste supplier quotes → auto rank + negotiation bullets',
    category: 'LOGISTICS',
    drilldowns: ['supplier_quotes'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  procurement_assistant: {
    id: 'procurement_assistant',
    name: 'AI Procurement Assistant',
    description: 'Enter need → draft request for quotes + email templates',
    category: 'LOGISTICS',
    drilldowns: ['supplier_quotes'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  fleet_recommender: {
    id: 'fleet_recommender',
    name: 'Fleet Utilization Recommender',
    description: 'Suggests optimal usage patterns from past logs',
    category: 'LOGISTICS',
    drilldowns: ['fleet_issues'],
    setupDays: '4-5',
    monthlyPrice: 10000
  },

  // HR & TEAM TOOLS
  jd_builder: {
    id: 'jd_builder',
    name: 'AI Job Description Builder',
    description: 'Write role + get polished JD ready to post',
    category: 'HR_TEAM',
    drilldowns: ['jd_time'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  interview_question_generator: {
    id: 'interview_question_generator',
    name: 'Interview Question Generator',
    description: 'Tailored questions + ideal answer cues (Role-wise)',
    category: 'HR_TEAM',
    drilldowns: ['interview_questions'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  onboarding_checklist_creator: {
    id: 'onboarding_checklist_creator',
    name: 'AI Onboarding Checklist Creator',
    description: 'Your business inputs → onboarding checklist for new hires',
    category: 'HR_TEAM',
    drilldowns: ['onboarding_messy'],
    setupDays: '2-3',
    monthlyPrice: 10000
  },
  employee_feedback_summarizer: {
    id: 'employee_feedback_summarizer',
    name: 'Employee Feedback Summarizer',
    description: 'Collects free-text → outputs themes & recommended actions',
    category: 'HR_TEAM',
    drilldowns: ['feedback_not_analyzed'],
    setupDays: '3-4',
    monthlyPrice: 10000
  },
  offer_letter_maker: {
    id: 'offer_letter_maker',
    name: 'AI HR-Friendly Offer Letter Maker',
    description: 'Input role + salary → generate compliant offer letters',
    category: 'HR_TEAM',
    drilldowns: ['manual_offers'],
    setupDays: '1-2',
    monthlyPrice: 10000
  },
  shift_scheduler: {
    id: 'shift_scheduler',
    name: 'AI Shift Scheduler',
    description: 'Enter hours + staff → fair rota + swap requests',
    category: 'HR_TEAM',
    drilldowns: ['onboarding_messy', 'feedback_not_analyzed'],
    setupDays: '3-4',
    monthlyPrice: 10000
  }
};

// Function to get recommended tools based on pain category
export const getRecommendedTools = (painCategory) => {
  if (!painCategory || painCategory === 'other') {
    // Return all tools for "Other" selection
    return Object.values(allTools);
  }
  
  // Return tools matching the pain category
  return Object.values(allTools)
    .filter(tool => tool.category === painCategory);
};

// Function to get all tools (for "Other" selections)
export const getAllTools = () => {
  return Object.values(allTools);
};

// Country codes for phone input
export const countryCodes = [
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'UAE' },
  { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
  { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
  { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' }
];
